export default __webpack_public_path__ + "static/media/financementeuro.fba869ad.jpg";